import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid, Paper, Typography, Button } from "@mui/material";

import dayjs from "dayjs";

import actions from "../../../../store/actions";
import ls from "../../../../Localization";
import { State } from "store/reducers";
import { UserDetailState } from "store/reducers/user/detail";
import useStyles from "./styles";
import { UserStatus } from "Types/User";
import { AsYouType } from "libphonenumber-js";
import { Helmet } from "react-helmet-async";
import { CPFCNPJ } from "Components/NumberFormat";
// import Subscriptions from "./Subscriptions";
// import Charges from "./Charges";
import { useNavigate, useParams } from "react-router-dom";
import { MeiLogisticOperatorStatus } from "Types/IMei";
import AuthTokens from "./AuthTokens";

export function UserDetail() {
	const navigate = useNavigate();
	const classes = useStyles({});
	const dispatch = useDispatch<any>();

	const { id } = useParams() as { id: string };

	useEffect(() => {
		dispatch(actions.user.detail.clearValues());
	}, [dispatch]);

	useEffect(() => {
		dispatch(actions.user.detail.getUser(id));
	}, [dispatch, id]);

	const { item }: any = useSelector<State, UserDetailState>(s => s.userDetail);

	const handleEdit = () => {
		navigate(`/Dashboard/User/${item._id}/Edit`);
	};

	if (!item) return null;

	const {
		createdAt,
		status,
		roles,
		name,
		lastname,
		email,
		cpf,
		birthDate,
		phoneNumber,
		address,
		userStatus,
		mei
	} = item;

	const role = roles?.find((c: any) => c !== "user") || roles[0];

	return (
		<Grid container justifyContent="center" spacing={5}>
			<Grid item xs={11}>
				<Helmet>
					<title>
						{name} {lastname} | {ls.appName}
					</title>
				</Helmet>
				<Paper className={classes.root}>
					<div className={classes.header}>
						<Typography variant="h6">{ls.clientData}</Typography>
						<div>
							<Button color="primary" onClick={handleEdit}>
								{ls.edit}
							</Button>
						</div>
					</div>
					<hr className={classes.line} />

					<Grid container spacing={2} className={classes.form}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.creationDate}</strong>:{" "}
							{dayjs(createdAt).format(ls.dateFormatWithoutSeconds)}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.name}</strong>: {name}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.lastName}</strong>: {lastname}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.email}</strong>: {email}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.role}</strong>: {ls[role]}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.phoneNumber}</strong>:{" "}
							{phoneNumber
								? new AsYouType("BR").input(
										phoneNumber?.replace("+55", "").match(/\d/g)?.join("")
								  )
								: ls.notDefined}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.birthDate}</strong>:
							{birthDate ? dayjs(birthDate).format(ls.dateFormatShort) : ""}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.cpf}</strong>:{" "}
							<CPFCNPJ displayType="text" value={cpf} />
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.userStatus}</strong>: {ls[UserStatus[userStatus]]}
						</Grid>

						{/* <Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.meiStatus}</strong>: {ls[MeiStatus[status || 0]]}
						</Grid> */}

						{(role === "logisticOperator" || role === "nfseController") && (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<strong>{ls.company}</strong>:{" "}
								{mei ? mei.businessName : "Nenhum"}
							</Grid>
						)}

						{address && (
							<Grid item xs={12}>
								<strong>{ls.address}</strong>:{" "}
								{`${address.street ?? ""}, ${address.number ?? ""} - ${
									address.complement ?? ""
								} - ${address.neighborhood ?? ""} - ${address.city ?? ""} - ${
									address.state ?? ""
								} - ${address.zipCode ?? ""}`}
							</Grid>
						)}
					</Grid>
				</Paper>
			</Grid>

			<AuthTokens userId={item._id} />

			{/* <Grid item xs={11}>
				<Subscriptions />
			</Grid>

			<Grid item xs={11}>
				<Charges />
			</Grid> */}
		</Grid>
	);
}

export default UserDetail;
